import { Link } from 'react-router-dom';

export function Contact() {
  return (
    <section className="screen">
      <div className="scroll narrow-scroll">
        <div className="ck-head">
          <h1>CONTACT</h1>
          <div className="p" style={{ fontSize: 14 }}>
            We&apos;re here to help.
          </div>
        </div>

        <div className="contact-card">
          <div className="ic-circle">
            <PackageIcon />
          </div>
          <div>
            <div className="ttl">RETURNS</div>
            <a className="email" href="mailto:returns@labelrotation.co.uk">
              returns@labelrotation.co.uk
            </a>
            <div className="desc">Questions about returns, labels or deadlines</div>
          </div>
        </div>

        <div className="contact-card">
          <div className="ic-circle">
            <MailIcon />
          </div>
          <div>
            <div className="ttl">GENERAL</div>
            <a className="email" href="mailto:team@labelrotation.co.uk">
              team@labelrotation.co.uk
            </a>
            <div className="desc">General enquiries, support or feedback</div>
          </div>
        </div>

        <div className="contact-strip">
          <div className="ic">
            <ClockIcon />
          </div>
          <div>We usually respond within 24 hours.</div>
        </div>

        <div className="contact-footnote">
          <div className="ic">
            <Info />
          </div>
          <div className="text">
            Please include your order number to help us speed things up.
          </div>
        </div>

        <div style={{ padding: '18px 22px 0', textAlign: 'center' }}>
          <div
            style={{
              fontSize: 11,
              letterSpacing: '0.14em',
              fontWeight: 600,
              color: 'var(--muted)',
              marginBottom: 10
            }}
          >
            LEGAL
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 18,
              flexWrap: 'wrap'
            }}
          >
            <Link
              to="/terms"
              style={{ fontSize: 13, textDecoration: 'underline', textUnderlineOffset: 3 }}
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to="/returns"
              style={{ fontSize: 13, textDecoration: 'underline', textUnderlineOffset: 3 }}
            >
              Returns &amp; Rental Policy
            </Link>
            <Link
              to="/privacy"
              style={{ fontSize: 13, textDecoration: 'underline', textUnderlineOffset: 3 }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/damage-loss"
              style={{ fontSize: 13, textDecoration: 'underline', textUnderlineOffset: 3 }}
            >
              Damage &amp; Loss
            </Link>
            <Link
              to="/cookies"
              style={{ fontSize: 13, textDecoration: 'underline', textUnderlineOffset: 3 }}
            >
              Cookie Policy
            </Link>
          </div>
        </div>
        <div style={{ height: 'calc(40px + env(safe-area-inset-bottom, 0))' }} />
      </div>
    </section>
  );
}

function PackageIcon() {
  return (
    <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M21 16V8l-9-5-9 5v8l9 5 9-5z" />
      <path d="M3.3 7l8.7 5 8.7-5" />
      <path d="M12 22V12" />
    </svg>
  );
}
function MailIcon() {
  return (
    <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}
function ClockIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}
function Info() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v4M12 16h0" />
    </svg>
  );
}
